import React from 'react';
import { Card, Table, Badge, Button, Alert } from 'react-bootstrap';
import { useDebounce } from '../../services/api/hooks/useDebounce';



const DebounceJobs: React.FC = () => {
  const { data: jobs, loading, error, refetch } = useDebounce();

  const getStatusBadge = (status: string) => {
    const variants = {
      pending: 'warning',
      processing: 'info',
      completed: 'success',
      failed: 'danger'
    };
    return <Badge bg={variants[status as keyof typeof variants]}>{status}</Badge>;
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString();
  };

  const openFile = (url: string) => {
    window.open(url, '_blank');
  };

  if (loading) {
    return (
      <Card className="m-3">
        <Card.Header as="h5">Debounce Jobs</Card.Header>
        <Card.Body className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="m-3">
      <Card.Header as="h5" className="d-flex justify-content-between align-items-center">
        Debounce Jobs
        <Button variant="outline-primary" size="sm" onClick={refetch}>
          Refresh
        </Button>
      </Card.Header>
      <Card.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        
        {jobs.length === 0 ? (
          <Alert variant="info">No debounce jobs found.</Alert>
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>ID</th>
                <th>File Name</th>
                <th>List ID</th>
                <th>Status</th>
                <th>Created</th>
                <th>Completed</th>
                <th>Result</th>
              </tr>
            </thead>
            <tbody>
              {jobs.map((job: any) => (
                <tr key={job.id}>
                  <td>{job.id}</td>
                  <td>
                    {job.upload_url ? (
                      <span 
                        style={{ cursor: 'pointer', color: '#0d6efd', textDecoration: 'underline' }}
                        onClick={() => openFile(job.upload_url!)}
                      >
                        {job.file_name}
                      </span>
                    ) : (
                      job.file_name
                    )}
                  </td>
                  <td>{job.debounce_list_id}</td>
                  <td>{getStatusBadge(job.status)}</td>
                  <td>{formatDate(job.created_at)}</td>
                  <td>{job.completed_at ? formatDate(job.completed_at) : '-'}</td>
                  <td>
                    {job.result_url && (
                      <Button 
                        variant="outline-success" 
                        size="sm"
                        onClick={() => openFile(job.result_url!)}
                      >
                        Download
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
};

export default DebounceJobs;